import React, { useEffect, useRef } from 'react'
import Image from 'next/image'
import { Button } from '@theneatcompany/nui'
import { FormattedMessage } from 'react-intl'
import { useRouter } from 'next/router'
import cx from 'classnames'

import NeatLogoSvg from '@/assets/svg/NeatLogo.svg'
import { ROUTES, SIDEBAR_ROUTES, SUBSCRIPTION_STATUSES } from '@/constants'
import Link from '@/components/common/Link'
import { useAccounts } from '@/components/Providers/AccountsProvider'
import { useUtils } from '@/components/Providers/UtilsProvider'
import useResponsiveDimensions from '@/hooks/useResponsiveDimensions'

import styles from './Sidebar.module.scss'

export default function Sidebar() {
  const { route } = useRouter()
  const { user, subscriptions: [base] } = useAccounts()
  const sidebarRef = useRef(null)
  const { sidebar: { isCollapsed, setCollapsed } } = useUtils()
  const { width } = useResponsiveDimensions(sidebarRef, !isCollapsed)
  const isExpired = base?.status === SUBSCRIPTION_STATUSES.EXPIRED

  useEffect(() => {
    if (width > 768) setCollapsed(true)
  }, [width])

  return (
    <nav id="sidebar" ref={sidebarRef} className={cx(styles.sidebar, !isCollapsed && styles.fullScreen)}>
      <div className={styles.logo}>
        <Link to={ROUTES.overview}>
          <div role="presentation" onClick={() => setCollapsed(true)}>
            <Image src={NeatLogoSvg} width={116} height={30} alt="Neat Logo" priority />
          </div>
        </Link>
        <div className={styles.sidebarClose}>
          <Button
            variant="secondary"
            iconOnly
            iconProps={{ name: 'close', title: 'menu' }}
            onClick={() => setCollapsed(true)}
          />
        </div>
      </div>
      <ul className={styles.items}>
        {Object.entries(SIDEBAR_ROUTES)
          .filter(([name]) => (name === 'paymentMethod' ? user.integrations?.recurlyId : true))
          .filter(([name]) => (['paymentMethod', 'subscription'].includes(name) ? !isExpired : true))
          .map(([name, path]) => (
            <li key={name} className={styles.item}>
              <Link
                to={path}
                className={cx(styles.itemLink, {
                  active: route === ROUTES.root ? path === SIDEBAR_ROUTES.overview : route === path,
                })}
              >
                <div role="presentation" onClick={() => setCollapsed(true)} className={styles.clickZone}>
                  <FormattedMessage id={`sidebar.routes.${name}`} />
                </div>
              </Link>
            </li>
          ))}
      </ul>
    </nav>
  )
}
